import React from 'react';
import {gettext} from 'utils/text';
import reverseUrl from 'utils/urls';

export default function EmptyCart() {
    return (
        <div className="cart--empty__container">
            <i className="icon icon--cart--large" />
            <h3>{gettext('Your basket is empty.')}</h3>
            <div className="sub--title">{gettext('But you can browse products by clicking a button below...')}</div>
            <div className="cart--controls">
                <a
                    className="btn btn-default btn-lg"
                    href={reverseUrl('catalogue:index')}
                >
                    {gettext('View products')}
                </a>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/cart/EmptyCart.js